import React, { Component } from "react";
import { connect } from "dva";
// eslint-disable-next-line
import router from "umi/router";
import { Button, Form, message, Spin, Tabs, Row, Col } from "antd";
import { Parse } from 'nbugs-pc-import-parse';
import { parse } from "qs";
import moment from 'moment';
import FormCreate from "../../../../components/FormCreate/index";
import styles from "./index.less";
import { getComposeUrl, specialRegex } from "../../../../utils/common";
import Container from "../../../../components/Container";
import PublishModal from "../Components/PublishModal";



const { TabPane } = Tabs;
const {
  FormTitle,
  SendTime,
  Publisher,
  MessageRemind,
  MonthPicker,
  SalaryUpload,
} = FormCreate;


@Form.create()
@connect(({ salaryCreate, user, loading }) => {
  return {
    loading:
      loading.effects["salaryCreate/fetchDetails"] ||
      loading.effects["salaryCreate/fetchSaveOrUpdate"] ||
      loading.effects["salaryCreate/fetchPublish"] ||
      false,
    draftBtnLoading: loading.effects["salaryCreate/fetchSaveDraft"] || false,
    currentUser: user.currentUser,
    ...salaryCreate,
  };
})

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      saveDraftFirst: true, // 首次保存草稿
      draftId: "" // 草稿id
    };
    this.query = parse(window.location.search.split("?")[1]);
  }

  componentDidMount() {
    const { currentUser, dispatch, formData } = this.props;
    const { schoolName } = currentUser;
    const { id } = this.query;
    if (id) {
      const { form } = this.props;
      const { setFieldsValue } = form;
      dispatch({
        type: "salaryCreate/save",
        payload: {
          id,
        }
      });
      dispatch({
        type: 'salaryCreate/fetchDetails',
        payload: {
          id,
        }
      }).then(res => {
        setFieldsValue({ ...res });
      })
    } else {
      dispatch({
        type: "salaryCreate/fetchSaveOrUpdate",
        payload: formData
      });
      dispatch({
        type: "salaryCreate/saveFormData",
        payload: {
          formData: {
            senderName: schoolName
          }
        }
      });
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    if (this.interval) {
      clearInterval(this.interval);
    }
    dispatch({
      type: 'salaryCreate/reset',
    });
  }

  handleSave = (payload) => {
    const { dispatch } = this.props;
    dispatch({
      type: "salaryCreate/save",
      payload
    });
  };

  // 保存表单数据
  handleFormDataChange = payload => {
    const { dispatch, form } = this.props;
    const { setFieldsValue } = form;
    setFieldsValue({ ...payload });
    dispatch({
      type: "salaryCreate/saveFormData",
      payload: { ...payload }
    });
  };

  // 当通知标题不为空后，每隔60s自动保存一次草稿
  startTimer = (e) => {
    if (!e.target.value) {
      return;
    }
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.handleSubmit({ status: 0, autoSave: true });
      }, 60000);
    }
  };

  /**
   * 必填项校验
   * @param fields 校验属性 数组
   * @param errMsg 校验出错提示信息
   * @param tab 出错时定位到具体tab
   */
  validateFieldsTask = (fields = [], errMsg = '', tab = '1') => {
    const { form } = this.props;
    const { validateFields } = form;
    return new Promise((resolve, reject) => {
      validateFields(fields, (err) => {
        if (err) {
          message.error(errMsg);
          this.changeTab(tab);
          reject(err);
        }
        return resolve();
      })
    });
  };

  handleOk = async status => {
    const { form, dispatch, formData } = this.props;
    const { getFieldsValue } = form;
    const { nameImportId } = formData;
    const values = getFieldsValue();
    const { title } = values;
    if (status === 0) {
      if (!title) {
        message.warning("请输入工资条名称后保存草稿");
        return;
      }
      this.handleSubmit({ status });
    } else {
      if (!nameImportId) {
        message.warning("请上传工资条");
        return;
      }
      await this.validateFieldsTask(['title', 'salaryMonth', 'message'], '信息填写页必填项未填写完整', '1');
      await this.validateFieldsTask(['senderName'], '发送属性页未填写完整', '3');
      dispatch({
        type: "salaryCreate/save",
        payload: { publishModalVisible: true }
      });
    }
  };



  titleInfo = title => {
    const regex = specialRegex;
    if ((regex.test(title))) {
      message.warning("工资表名称请勿输入特殊字符或表情");
      return false;
    }
    return true
  };

  // 保存
  handleSubmit = ({ autoSave, status = 1, saveDraft = false }) => {

    const { dispatch, formData, form, id } = this.props;
    const { salaryMonth } = formData;
    const { getFieldsValue } = form;
    const values = getFieldsValue();
    const { title, isTiming, } = values;

    const titleInfo = this.titleInfo(title);

    if (!titleInfo) {
      return;
    }

    if (status === 0 && !title) {
      message.error("请输入工资条名称后保存草稿");
      return;
    }

    formData.salaryMonth = moment(salaryMonth).format('YYYY.MM')
    values.salaryMonth = moment(values.salaryMonth).format('YYYY.MM')

    dispatch({
      type: "salaryCreate/fetchSaveOrUpdate",
      payload: {
        ...formData,
        ...values,
        id,
      }
    }).then(data => {
      if (status == 1) {
        dispatch({
          type: "salaryCreate/fetchPublish",
          payload: {
            id,
            publishType: this.query.sendStatus == 4 ? 3 : isTiming == 1 ? 2 : 1  //发布类型，(1,立即发布)(2,定时发布),(3,补发)
          }
        })
        return;
      } else {
        if (saveDraft) {
          // 手动保存草稿退回到发件箱列表
          router.push(getComposeUrl("/wages/management"));
          return;
        }
      }
    })
  };

  changeTab = activeKey => {
    const { dispatch } = this.props;
    dispatch({
      type: "salaryCreate/save",
      payload: { activeKey }
    });
  };

  resetInitiatorName = value => {
    const { currentUser, form } = this.props;
    const { name, schoolName } = currentUser;
    const { setFieldsValue } = form;
    setFieldsValue({ senderName: value === "dept" ? schoolName : name });
  };

  nextStep = () => {
    const { activeKey } = this.props;
    this.changeTab(`${Number(activeKey) + 1}`);
  };

  preStep = () => {
    const { activeKey } = this.props;
    this.changeTab(`${Number(activeKey) - 1}`);
  };

  renderTabTitle = (activeKey, title, index) => {
    return (
      <span>
        <i
          className={
            activeKey === index ? "common-icon-style active-style" : "common-icon-style icon-style"
          }
        >
          {index}
        </i>
        {title}
      </span>
    );
  };


  renderFooter = () => {
    const { activeKey, formData, type = "create", form, draftBtnLoading } = this.props;
    const { getFieldValue } = form;
    const { sendState, btnStatus, isTiming } = formData;
    return {
      states: !0,
      demFooter: (
        <>
          {(sendState === 4 || type === "create") && (
            <Button
              type="default"
              loading={draftBtnLoading}
              onClick={() => this.handleSubmit({ status: 0, autoSave: false, saveDraft: true })}
            >
              存为草稿
            </Button>
          )}
          {["2", "3"].indexOf(activeKey) > -1 && (
            <Button type="default" onClick={this.preStep}>
              上一步
            </Button>
          )}
          {["1", "2"].indexOf(activeKey) > -1 && (
            <Button type="primary" onClick={this.nextStep}>
              下一步
            </Button>
          )}
          {activeKey === "3" && (
            <Button
              type="primary"
              onClick={() => this.handleOk(1)}
              className={`login-form-button ${btnStatus ? "" : ""}`}
            >
              {getFieldValue("isTiming") || isTiming ? "保存" : "发布"}
            </Button>
          )}
        </>
      )
    };
  }

  onTaskIdChange = taskId => {
    const { dispatch } = this.props;
    dispatch({
      type: "salaryCreate/saveFormData",
      payload: {
        formData: {
          nameImportId: taskId
        }
      }
    })
    if (taskId) {
      this.changeTab('2');
      // this.handleSubmit()
    }
  };

  render() {
    const {
      form,
      formData,
      spinProps,
      loading,
      currentUser,
      activeKey,
      publishModalVisible
    } = this.props;

    const { orgType } = currentUser || {};
    const {
      title,
      senderName,
      senderType,
      isTiming,
      fileCount,
      publishTimeString,
      receiveUserTemplate,
      message: content,
      msgSendSetting,
      salaryMonth,
      id,
      nameImportId,
    } = formData;

    const {
      getFieldValue,
      getFieldsValue
    } = form;

    const monthProps = {
      form,
      value: salaryMonth,
      label: '发放月份',
      keyName: 'salaryMonth',
      message: '请选择月份',
      onOk: this.handleMonthPicker,
    };

    const titleProps = {
      form,
      keyName: "title",
      value: title,
      onChange: this.startTimer,
      label: "工资表名称",
      maxLength: 100,
      suffix: `${(getFieldValue("title") && getFieldValue("title").length) || 0}/100`
    };

    const uploadProps = {
      form,
      value: '',
      keyName: 'upload',
      label: '工资表',
      appId: '23',
      sceneSign: 'import_2',
      businessId: id,
      taskId: nameImportId,
      message: '请上传工资表',
      onTaskIdChange: this.onTaskIdChange,
    }

    const parseProps = {
      taskId: nameImportId,
      onTaskIdChange: this.onTaskIdChange,
    };

    const publisherProps = {
      form,
      nameKeyName: "senderName",
      typeKeyName: "senderType",
      initiatorNameType: senderType,
      initiatorName: senderName,
      resetInitiatorName: this.resetInitiatorName,
      typeGroupOptions: [
        { label: "部门", value: "dept" },
        { label: "个人", value: "personal" }
      ]
    };

    const sendTimeProps = {
      form,
      isTiming: isTiming,
      publishTimeString: publishTimeString,
    };

    const messageRemindProps = {
      keyName: "msgSendSetting",
      form,
      value: Number(msgSendSetting)
    };

    return (
      <Container defaultPadding breStates={!0} version={2} footerParams={this.renderFooter()}>
        <div className={styles.root}>
          <Spin {...spinProps}>
            <FormCreate>
              <Tabs defaultActiveKey="1" activeKey={activeKey} className={`activeKey${activeKey}`} onChange={this.changeTab}>
                <TabPane tab={this.renderTabTitle(activeKey, "信息填写", "1")} key="1">
                  <MonthPicker {...monthProps} />
                  <FormTitle {...titleProps} />
                  <SalaryUpload {...uploadProps} />
                </TabPane>
                <TabPane tab={this.renderTabTitle(activeKey, "信息确认", "2")} key="2">
                  <div className='infomationSure'>
                    <Parse {...parseProps} />
                  </div>
                </TabPane>
                <TabPane tab={this.renderTabTitle(activeKey, "发送属性", "3")} key="3">
                  <Publisher {...publisherProps} />
                  <MessageRemind {...messageRemindProps} />
                  {
                    this.query.sendStatus != '4' && <SendTime {...sendTimeProps} />
                  }
                </TabPane>
              </Tabs>
            </FormCreate>
            <PublishModal
              sendStatus={this.query.sendStatus}
              loading={loading}
              orgType={orgType}
              publishModalVisible={publishModalVisible}
              values={{
                ...getFieldsValue(),
                receiveUserTemplate: getFieldsValue().receiveUserTemplate || receiveUserTemplate,
                fileCount
              }}
              handleOk={this.handleSubmit}
              handleCancel={() => {
                this.handleSave({ publishModalVisible: false });
              }}
            />
          </Spin>
        </div>
      </Container>
    );
  }
}

export default Index;
